import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureTrackingParams } from "@/lib/tracking";

const TrackingInit = () => {
  const location = useLocation();

  useEffect(() => {
    captureTrackingParams();
  }, [location.pathname, location.search]);

  return null;
};

export default TrackingInit;
